<template>
  <div class="nat-user-info">
    <van-form @submit="onSubmit" class="nat-user-info-form">
      <van-field
        v-model="name"
        :rules="[
          {
            required: true,
            message: '请填写姓名'
          }
        ]"
        name="name"
        label="姓名"
        placeholder="姓名"
      />
      <van-field
        v-model="idCard"
        :rules="[
          {
            required: true,
            message: '请填写证件号'
          }
        ]"
        name="idCard"
        label="证件号"
        placeholder="证件号(非卡号)"
      />
      <!-- <van-field
        v-model="phone"
        name="phone"
        type="number"
        placeholder="手机号"
        :rules="[
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: '请填写正确的手机号'
          }
        ]"
      /> -->
      <ph-button
        class="nat-user-info-button"
        title="下一步"
        native-type="submit"
      />
    </van-form>
    <div class="nat-user-info-tip">
      <p>注意事项</p>
      <div>
        1、证件号输入请填写您当时在医院建档时预留的证件号，如未建档，请优先填写身份证号<br />
        2、切记做好个人防护，全程正确佩戴口罩，保持1米以上安全距离，避免交谈，有序配合<br />
        3、系统会自动检测您的就诊卡号信息，如未检测到就诊卡信息会自动引导您进行建档预约<br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      openId: "",
      name: "",
      idCard: "",
      phone: ""
    };
  },
  created() {
    this.openId = this.$route.query.openId;
  },
  methods: {
    onSubmit(value) {
      if (!this.$regular.idCard(this.idCard)) {
        this.$toast("请输入正确的身份证号");
        return;
      }
      this.$http.post(this.$api.TEST_IS_JD, value).then(({ flag }) => {
        if (flag == "1") {
          this.gotoCommit(value);
        } else {
          this.gotoBuilding(value);
        }
      });
    },
    gotoCommit({ name, idCard }) {
      // const path = `./pay.html?openId=${this.openId}&name=${name}&idCard=${idCard}`;
      // window.location.href = path;
      this.$router.push({
        name: "nucleic-acid-test-nat",
        query: {
          openId: this.openId,
          name,
          idCard
        }
      });
    },
    gotoBuilding(value) {
      this.$router.push({
        name: "nucleic-acid-user-building",
        query: {
          openId: this.openId,
          ...value
        }
      });
    }
  }
};
</script>

<style lang="less">
.nat-user-info {
  &-form {
    padding: 0.8rem;
    background: white;

    .van-cell__title {
      font-size: 0.94rem;
    }
    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
  }

  &-button {
    margin-top: 1rem;
  }

  &-tip {
    margin: 0.75rem 1.19rem;
    padding-bottom: 1rem;
    background: white;
    border-radius: 0.5rem;

    p {
      padding-left: 0.5rem;
      line-height: 2.31rem;
      border-radius: 0.5rem 0.5rem 0 0;
    }
    > div {
      display: flex;
      padding: 0 0.5rem;
      font-size: 0.81rem;
      div {
        flex-shrink: 0;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: 0.4rem;
        margin-right: 1rem;
        background: #108eee;
        border-radius: 0.3rem;
      }
    }
  }
}
</style>
